'use strict';

angular.module('app.reports')
  .factory('MailingLabels', MailingLabels);

function MailingLabels(esriLoader, $q, $http, appConfig) {
  let service = {
    create: create,
    mailingLabels: mailingLabels
  };

  return service;

  // Load all reports in the system
  function create(tract, map, parcels, dist) {
    let d = $q.defer();
    drawBuffer(tract, map, dist).then(function(buffer) {
      selectParcels(buffer, parcels).then(function(features) {
        mailingLabels(features).then(function(pdf) {
          d.resolve(pdf);
        });
      });
    });
    return d.promise;
  }

  // generate the mailing labels
  function mailingLabels(features) {
    return $http.post('/api/v1/reports/mailinglabels', {
        features: features
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function drawBuffer(tract, map, dist) {
    let d = $q.defer();
    esriLoader.require([
      'esri/geometry/geometryEngine',
      'esri/graphic',
      'esri/Color',
      'esri/symbols/SimpleFillSymbol',
      'esri/symbols/SimpleLineSymbol'
    ], function(
      geometryEngine,
      Graphic,
      Color,
      SimpleFillSymbol,
      SimpleLineSymbol
    ) {
      let theBuffer = geometryEngine.buffer(tract.geometry, dist, 'feet');
      // feature selection symbol
      let polygonDrawSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_NULL,
        new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
          new Color([255, 255, 0]), 4),
        new Color([255, 255, 255, 0.8])
      );
      let graphic = new Graphic(theBuffer, polygonDrawSymbol);
      map.graphics.add(graphic);
      d.resolve(theBuffer);
    });
    return d.promise;
  }

  function selectParcels(buffer) {
    let d = $q.defer();
    esriLoader.require([
      'esri/tasks/query',
      'esri/tasks/QueryTask'
    ], function(
      Query,
      QueryTask
    ) {
      let query = new Query();
      query.geometry = buffer;
      query.spatialRelationship = Query.SPATIAL_REL_INTERSECTS;
      query.returnGeometry = false;
      query.outFields = ['*'];
      console.log('parcel service: ', appConfig.getConfig().parcelService)
      let queryTask = new QueryTask(appConfig.getConfig().parcelService);
      queryTask.execute(query, function(results) {
        let mailFeatures = [];
        for (let id in results.features) {
          if (results.features[id].attributes.OWNAME != null) {
            if (contains(['TAX FORFEITED', 'CROW WING COUNTY', 'STATE OF MINNESOTA DEPT OF TRANS', 'STATE OF MINNESOTA DEPARTMENT OF', 'STATE OF MINNESOTA  ADMIN BLDG', 'STATE OF MINNESOTA DNR-'], results.features[id].attributes.OWNAME) === false) {
              mailFeatures.push(results.features[id].attributes);
            }
          }
        }
        d.resolve(mailFeatures);
      });
    });
    return d.promise;
  }

  function contains(array, element){
    return array.indexOf(element.trim()) > -1;
  }
}
